export const AuthSources = {
  Salesforce: 'Salesforce',
} as const;

export type AuthSource = typeof AuthSources[keyof typeof AuthSources];

export type AuthSourceData = Readonly<{
  source: AuthSource;
  targetOrigin?: string;
}>;
